import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Card, Spin, Upload,
} from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Box, Flex, Text,
} from '../../shared/components';
import {
  fetchCurrentDirectory,
  initialize,
  uploadDocumentToCurrentDirectory,
  establecerDirectorioActual,
  requestEditDocumentById,
  seleccionarDocumentos,
  eliminarDocumentosDB,
  cargarEntidadesRequest,

} from '../../../state/actions/creators/drive.actioncreator';
import EditDocumentModal from '../components/feedback/editDocument.modal';
import TablaFicheros from '../components/dataDisplay/ficherosTabla.dataDisplay';
import { entidadSeleccionadaSelector } from '../../../state/selectors/drive.selectors';
import { obtenerValorPermiso } from '../../../helpers/auth.helper';

class GioDrivePage extends React.Component {

  componentDidMount() {
    const { fetchCurrentDirectory, initialize } = this.props;
    const { drive } = this.props;
    const { cargarEntidadesRequest } = this.props;
    const { entidades } = drive;
    const {
      establecerDirectorioActual, match: { params: { entidadTipoId, entidadId, tiendaId } },
    } = this.props;
    if (entidades.length === 0) {
      cargarEntidadesRequest();
    }
    initialize();
    establecerDirectorioActual({ entidadTipoId, entidadId, tiendaId });
    fetchCurrentDirectory();
    this.uploadModal = React.createRef();
  }

  eliminarFicherosSeleccionados() {
    const { drive: { currentDirectory: { selected: { files } } } } = this.props;
    const { eliminarDocumentos, seleccionarDocumentos } = this.props;
    eliminarDocumentos({
      documentos: files,
    });
    seleccionarDocumentos({ selectedRowKeys: [], documentos: null });
  }

  guardarFichero({ file, name, descripcion }) {
    const { uploadDocumentToCurrentDirectory } = this.props;
    uploadDocumentToCurrentDirectory({
      file,
      name,
      descripcion,
    });
  }

  editarFichero(row) {
    this.uploadModal.current.setFileToEdit(row);
    this.uploadModal.current.open();
  }

  actualizarFichero({ id, nombre, descripcion }) {
    const { requestEditDocumentById } = this.props;
    requestEditDocumentById({ id, nombre, descripcion });
    this.uploadModal.current.close();
  }

  seleccionarDocumentos({ selectedRowKeys, selectedRows }) {
    const { seleccionarDocumentos } = this.props;
    seleccionarDocumentos({ selectedRowKeys, documentos: selectedRows });
  }

  render() {
    const { drive: { currentDirectory: { files, selected: { keys: selectedRowKeys } }, porcentajeTotalUso, totalGBContratado }, entidadSeleccionada } = this.props;
    const {
      requestStatus, uploadingFileStatus, removeDocumentsStatus, permisos,
    } = this.props;

    const spinning = (requestStatus) ? requestStatus.running : false;

    const stringNumeroDocumentos = `${files.length} documentos`;
        
    const stringEspacioUtilizado = (totalGBContratado === null) ? '' :`(Usado ${porcentajeTotalUso}% de ${totalGBContratado}Gb)`;
    let nombreCarpeta = '';

    if(entidadSeleccionada) {
      const { nombreTraducido } = entidadSeleccionada;
      nombreCarpeta = `${nombreTraducido}`;
    }


    const uploading = (uploadingFileStatus) ? uploadingFileStatus.running : false;

    const uploaderProps = {
      showUploadList: false,
      beforeUpload: (file) => {
        this.guardarFichero({ file, name: '', descripcion: '' });
        return false;
      },
    };

    let deleteDisabled = false;

    if (removeDocumentsStatus) {
      const { running } = removeDocumentsStatus;
      if (running) {
        deleteDisabled = true;
      }
    }

    let puedeEditar = obtenerValorPermiso({
      permisos, 
      clave: 'permitir_editar_documentos',
      tipo: 'permiso'});

    return (
      <Box>
        <EditDocumentModal
          ref={this.uploadModal}
          loading={uploading}
          onGuardarDocumento={({ id, nombre, descripcion }) => this.actualizarFichero({ id, nombre, descripcion })}
        />

        <Box p="16">
          <Flex py="16" justifyContent="space-between">
            <Box>
              <Text fontSize="24">{nombreCarpeta}</Text>
            </Box>
            <Box>
              <Box display="inline-block" mr="8">
                <Button disabled={deleteDisabled} icon="delete" hidden={!puedeEditar} onClick={() => this.eliminarFicherosSeleccionados()} />
              </Box>
              <Upload
                disabled={uploading}
                {...uploaderProps}
              >
                <Button type="primary" loading={uploading} hidden={!puedeEditar}>
                  Añadir
                </Button>
              </Upload>
            </Box>
          </Flex>
          <Card>
            <Box mb="16">
              <Text fontWeight="semibold">{stringNumeroDocumentos}</Text>
              <Text fontSize="12" mt="4" display="block">{stringEspacioUtilizado}</Text>
            </Box>
            <Spin spinning={spinning}>
              <TablaFicheros
                onRowSelection={(selectedRowKeys, selectedRows) => this.seleccionarDocumentos({ selectedRowKeys, selectedRows })}
                selectedRowKeys={selectedRowKeys}
                files={files}
                onEditarClicked={row => this.editarFichero(row)}
              />
            </Spin>
          </Card>
        </Box>

      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  const permisos = state.auth.permisos;
  const { drive, sagas: { DRIVE_FETCH_CURRENT_DIRECTORY: requestStatus, DRIVE_UPLOAD_TO_CURRENT_DIRECTORY: uploadingFileStatus, DRIVE_REMOVE_DOCUMENTS: removeDocumentsStatus } } = state;
  return {
    permisos,
    drive,
    requestStatus,
    uploadingFileStatus,
    removeDocumentsStatus,
    entidadSeleccionada: entidadSeleccionadaSelector(state),
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchCurrentDirectory,
    initialize,
    uploadDocumentToCurrentDirectory,
    establecerDirectorioActual,
    requestEditDocumentById,
    seleccionarDocumentos,
    cargarEntidadesRequest,
    eliminarDocumentos: eliminarDocumentosDB,
  }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GioDrivePage);

GioDrivePage.propTypes = {
  drive: PropTypes.shape({
    currentDirectory: PropTypes.shape({
      files: PropTypes.any,
      selected: PropTypes.any,
    }),
    entidades: PropTypes.array.isRequired,
  }).isRequired,
  eliminarDocumentos: PropTypes.func.isRequired,
  fetchCurrentDirectory: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  removeDocumentsStatus: PropTypes.func,
  requestEditDocumentById: PropTypes.func.isRequired,
  requestStatus: PropTypes.shape({
    running: PropTypes.bool,
  }),
  seleccionarDocumentos: PropTypes.func.isRequired,
  cargarEntidadesRequest: PropTypes.func.isRequired,
  establecerDirectorioActual: PropTypes.func.isRequired,
  uploadDocumentToCurrentDirectory: PropTypes.func.isRequired,
  uploadingFileStatus: PropTypes.shape({
    running: PropTypes.bool,
  }),
};

GioDrivePage.defaultProps = {
  requestStatus: {
    running: false,
  },
  uploadingFileStatus: {
    running: false,
  },
  removeDocumentsStatus: () => {

  },
};
